import { Component, Ref } from '@eastsideco/salvo-ts';
import { ThemeComponent } from '@/theme/ThemeComponent';

@Component
export class CustomerForm extends ThemeComponent {
    @Ref({ required: false }) recoverToggle!: HTMLButtonElement[];
    @Ref({ required: false }) recover!: HTMLElement;
    @Ref() form!: HTMLElement;
    @Ref() guestLogin!:HTMLElement;

    protected url = location.href;

    /**
     * Initialise.
     */
    init() {
        this.showForm();
        for (const button of this.recoverToggle) {
            button.addEventListener("click", () => this.handlePasswordRecover());
        }
        if (location.href.indexOf('checkout_url=/tools/recurring/login') >= 0) {
            this.guestLogin.classList.add('hidden');
        }
    }

    /**
     * Toggle Recover password form.
     */
    handlePasswordRecover() {
        this.recover.classList.toggle('is-active');
        this.form.classList.toggle('hidden');
    }

    /**
     * Show / hide forms based of consitions.
     * @returns
     */
    showForm() {
        if (!this.classList.contains('account-form--customer_login')) {
            this.form.classList.remove('hidden');
            return;
        }

        if (this.recover.querySelector('.errors') === null && location.href.indexOf('#recover') <= -1) {
            this.recover.classList.remove('is-active');
            this.form.classList.remove('hidden');
            return;
        }


        this.recover.classList.add('is-active');
        this.form.classList.add('hidden');
    }
}
